import { render, staticRenderFns } from "./ConsumerHome.vue?vue&type=template&id=4e316af4&scoped=true&"
import script from "./ConsumerHome.vue?vue&type=script&lang=js&"
export * from "./ConsumerHome.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerHome.vue?vue&type=style&index=0&id=4e316af4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e316af4",
  null
  
)

export default component.exports